import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map, Observable, tap } from 'rxjs';

export interface Enhancement {
	maxStockCount: number;
	hidden: boolean;
	name: string;
	id: string;
	globalServiceId: string;
	data: {
		room?: string;
		pmtTyp: string;
		category: string;
    categoryTitle: string;
		image: string;
	};
	description: string;
	itemHasStock: boolean;
	price: number;
}

export interface Category {
  value: string;
  title: string
}

@Injectable({
	providedIn: 'root',
})
export class EnhancementsService {
	apiService = inject(ApiService);

	getEnhancements(
		companyId: number,
		serviceId: number,
		category?: string
	): Observable<Enhancement[]> {
		return this.apiService
			.getServiceItemExtras(companyId, serviceId, category)
			.pipe(
        map((extras) => extras.map(this.mapToEnahncementItem)),
        tap(console.log)
    );
	}

	getCategories(enhancements: Enhancement[]): Category[] {
		const categories = [];
		enhancements.forEach((item) => {
			if (!categories.includes(item.data.category)) {
				categories.push({value: item.data.category, title: item.data.categoryTitle});
			}
		});
		return categories;
	}

	mapToEnahncementItem(item: Record<string, any>): Enhancement {
		return {
			description: item.item_description,
			maxStockCount: item.item_max_stock_count,
			hidden: item.item_hidden,
			name: item.item_name,
			id: item.item_id,
			globalServiceId: item.global_service_id,
			data: {
        pmtTyp: item.data.pmtTyp,
        category: item.data.category,
        categoryTitle: item.data.category_title,
        image: item.data.image,
      },
			itemHasStock: item.item_has_stock,
			price: item.item_price,
		};
	}
}
